import { connect } from 'react-redux'
import TableView from '../../../../common/containers/TableView'
import { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { callCompanyListGet, callCompanyDelete } from '../../actions/companies'
import { Link, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'

let CompanyList = ({ setPageAttr, list, methods: { callCompanyListGet, callCompanyDelete } }) => {
    let [searchParams] = useSearchParams();
    const remove = (id) => {
        Swal.fire({
            title: 'Tem certeza que deseja deletar? Essa ação não poderá ser desfeita!',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then((result) => {
            if (result.isConfirmed) {
                callCompanyDelete(id, () => {
                    let pg = searchParams.get('pg')
                    pg = pg ? pg : 1
                    callCompanyListGet({}, pg)
                })
            }
        })
    }
    const headers = [
        {
            type: 'info',
            name: 'id',
            align: 'right',
            label: 'ID'
        },
        {
            type: 'info',
            name: 'name',
            align: 'left',
            label: 'Nome'
        },
        {
            type: 'datetime',
            name: 'createdAt',
            align: 'right',
            label: 'Cadastro'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Opções',
            custom: (a) => {
                return (
                    <>
                        <Link to={'/companies/edit/' + a.id} className='btn btn-sm btn-primary'><i className='fas fa-edit'></i></Link>
                        <span className='btn btn-sm btn-danger ml-2' onClick={() => remove(a.id)}><i className='fas fa-trash'></i></span>
                    </>
                )
            }
        }
    ]

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callCompanyListGet({}, pg)
    }, [callCompanyListGet, searchParams])

    useEffect(() => {
        setPageAttr({
            title: 'Empresas',
            caption: 'Gestão dos dados das empresas',
            btns: [
                {
                    type: 'link',
                    class: 'btn btn-primary',
                    icon: 'fas fa-plus',
                    label: 'Adicionar',
                    to: '/companies/add'
                }
            ],
            tabs: [
                {
                    active: true,
                    to: '/companies',
                    label: 'Informações'
                }
            ]
        })
    }, [setPageAttr])

    return (
        <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/companies'} />
    )
}

const mapStateToProps = ({ register: { companies: { list } } }) => ({
    list: list,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callCompanyListGet,
            callCompanyDelete
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyList)